import { useState } from "react";
import { faqs } from "@/mocks/home";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="mx-auto w-full max-w-4xl px-4 md:px-6 lg:px-10">
        <div className="reveal text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium uppercase tracking-[0.16em] text-secondary-800">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-500" />
            FAQ
          </span>
          <h2 className="mt-4 font-heading text-3xl font-semibold text-foreground-950 md:text-4xl">
            Questions about green steel
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-foreground-600">
            Everything you need to know about green hydrogen, HBI, and how our pilot fits India's green steel rules.
          </p>
        </div>

        <div className="mt-10 space-y-3">
          {faqs.map((faq, index) => {
            const isOpen = open === index;
            return (
              <div
                key={faq.q}
                className="reveal overflow-hidden rounded-lg border border-background-200 bg-background-100/50"
                style={{ transitionDelay: `${index * 50}ms` }}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : index)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                >
                  <span className="font-heading text-base font-semibold text-foreground-950">{faq.q}</span>
                  <i
                    className={`flex-none text-xl text-primary-600 transition-transform duration-300 ${
                      isOpen ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  />
                </button>
                <div
                  className={`grid transition-all duration-300 ease-out ${
                    isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600 md:px-6">{faq.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}